module.exports = __webpack_public_path__ + "static/media/team.081e6007.jpg";